import { Navigate, RouteObject } from 'react-router-dom';
import UiKitContainer from './ui-kit.tsx';
import InputField from './input-filed/input-field.tsx';
import ButtonComponent from './button/button-component.tsx';
import TypographyComponent from './typography/typography.tsx';
import DialogComponent from './app-dialog/dialog.tsx';
import Autocomplete from './app-autocomplete/autocomplete.tsx';
import SnackbarComponent from './app-snackbar/snackbar.tsx';
import SelectAllTable from './select-all-table/select-all-table.tsx';
import TimePickerComponent from '@ui-kit/time-picker/time-picker.tsx';
import ImageCropEditor from '@ui-kit/image-crop-editor/image-crop-editor.tsx';
import MediaLibrary from '@ui-kit/media-library/media-library.tsx';
import UiKitDateRange from '@ui-kit/ui-kit-date-range/ui-kit-date-range.tsx';
import CheckboxAndRadio from '@ui-kit/checkbox-and-radio/checkbox-and-radio.tsx';
import UiKitTabs from '@ui-kit/ui-kit-tabs/ui-kit-tabs.tsx';
import ColorsComponent from '@ui-kit/colors/colors.tsx';
import StatusSelectComponent from '@ui-kit/status-select/status-select.tsx';
import InfoTooltipComponent from '@ui-kit/info-tooltip/info-tooltip.tsx';
import PaginationShowcase from '@ui-kit/pagination/pagination.tsx';
import ProgressListShowcase from '@ui-kit/progress-list/progress-list.tsx';
import CardsComponent from '@ui-kit/cards/cards.tsx';
import ChartsComponent from '@ui-kit/charts/charts.tsx';
import IconsComponent from '@ui-kit/icons/icons.tsx';
import LoaderComponent from '@ui-kit/loader/loader.tsx';

export const uiKitRoutes: RouteObject[] = [
  {
    path: '',
    element: <UiKitContainer />,
    children: [
      {
        path: '',
        element: <Navigate to="colors" />
      },
      {
        path: 'colors',
        element: <ColorsComponent />
      },
      {
        path: 'icons',
        element: <IconsComponent />
      },
      {
        path: 'input-field',
        element: <InputField />
      },
      {
        path: 'checkbox-and-radio',
        element: <CheckboxAndRadio />
      },
      {
        path: 'autocomplete',
        element: <Autocomplete />
      },
      {
        path: 'typography',
        element: <TypographyComponent />
      },
      {
        path: 'button',
        element: <ButtonComponent />
      },
      {
        path: 'time-picker',
        element: <TimePickerComponent />
      },
      {
        path: 'dialog',
        element: <DialogComponent />
      },
      {
        path: 'tabs',
        element: <UiKitTabs />
      },
      {
        path: 'snackbar',
        element: <SnackbarComponent />
      },
      {
        path: 'table',
        element: <SelectAllTable />
      },
      {
        path: 'image-crop-editor',
        element: <ImageCropEditor />
      },
      {
        path: 'media-library',
        element: <MediaLibrary />
      },
      {
        path: 'date-range',
        element: <UiKitDateRange />
      },
      {
        path: 'status-select',
        element: <StatusSelectComponent />
      },
      {
        path: 'info-tooltip',
        element: <InfoTooltipComponent />
      },
      {
        path: 'pagination',
        element: <PaginationShowcase />
      },
      {
        path: 'progress-list',
        element: <ProgressListShowcase />
      },
      {
        path: 'cards',
        element: <CardsComponent />
      },
      {
        path: 'charts',
        element: <ChartsComponent />
      },
      {
        path: 'loader',
        element: <LoaderComponent />
      }
    ]
  }
];
